'use client'

import HelpCategoryContent from '@/app/help/HelpCategoryContent'
import { helpContent } from '@/app/help/helpContent'
import TutorialPlayerModal from '@/app/help/TutorialPlayerModal'
import { HelpTutorial, useTutorials } from '@/app/help/tutorials'
import Modal from '@/components/Modal/Modal'
import { useCallback, useState } from 'react'

export type ContextualHelpCategoryId = 'orders' | 'products' | 'media' | 'settings'

type ContextualHelpModalProps = {
  categoryId: ContextualHelpCategoryId
  isOpen: boolean
  onClose: () => void
}

const ContextualHelpModal = ({ categoryId, isOpen, onClose }: ContextualHelpModalProps) => {
  useTutorials()
  const [selectedTutorial, setSelectedTutorial] = useState<HelpTutorial | null>(null)
  const closeTutorial = useCallback(() => setSelectedTutorial(null), [])
  const category = helpContent.find((item) => item.id === categoryId)

  if (!category) return null

  return (
    <>
      <TutorialPlayerModal tutorial={selectedTutorial} onClose={closeTutorial} />
      <Modal isOpen={isOpen} onClose={onClose} title="Help" className="!p-0" closeOnOutsideClick={false}>
        <div className="max-h-[calc(100vh-220px)] w-[900px] max-w-[calc(100vw-80px)] overflow-y-auto p-xl">
          <HelpCategoryContent category={category} onPlayTutorial={setSelectedTutorial} />
        </div>
      </Modal>
    </>
  )
}

export default ContextualHelpModal
